import { Link as MuiLink, Typography } from '@mui/material';
import { Link } from 'react-router';
import { Widget, WidgetVariant } from '@tap/mui-ui';

/*
*   Виджет: начало работы
*/
export default function BeginningWorkWidget() {

    return (
        <Widget
            title={'Начало работы'}
            variant={WidgetVariant.Info}
        >
            <Typography mb={1}>
                Добро пожаловать в ТАП MES!
            </Typography>

            <Typography mb={1}>
                Не знаете как начать? Посмотрите руководство пользователя в&nbsp;
                <MuiLink component={Link} to={'help'}>
                    разделе документации
                </MuiLink>
                .
            </Typography>

            <Typography>
                Для начальной загрузки данных - перейдите в сменно-суточные задания и загрузите их из ТАП APS.
            </Typography>
        </Widget>
    );
}